export class AppConsts {

    static showNoInternet = false;
    static showData = true;
    static remoteServiceBaseUrl: string;
    static appBaseUrl: string;
    static accountingBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'Cams'
    };

    static readonly authorization = {
        encryptedAuthTokenName: 'enc_auth_token',
        AuthToken:'Abp.AuthToken'
    };

    public static phoneNumber = {
        minLength : 9,
        maxLength : 10
    }

    public static currency = "";

    public static currencySign = "";

    static readonly appModule = {
        Sacos: 'Sacos',
        Merrygoround: 'Merrygoround',
        Microfinance: 'Microfinance'
    };

    public static allowedImageMimeType = ["application/pdf",'image/jpeg','image/jpg','image/png','image/x-citrix-jpeg','image/x-citrix-png','image/x-png'];
    public static allowedTextMimeType = ['text/csv'];
    public static destinationType = {mno:"MNO",bank:'Bank'};
    static culture: string;
    static apppath:string;

    public static dialogId = {
        ROOTED_DEVICE_DIALOG: 'rooted-device-dialog'
    }

  static SSO = {
    "url": "",
    "redirect_uri": `${window.location.origin}/account/authenticate`,
    "logout_redirect_uri": `${window.location.origin}/account/authenticate`,
    "redirect_uri_mobile": 'wakandimember://sso-mobile',
    "client_id": "", 
    "grant_type": "authorization_code",
    "response_type": "code",
    "token": "Wak.Token",
    "refreshToken": "Wak.RefreshToken",
  }
}
